const NOW_PLAYING_ENDPOINT = `https://api.spotify.com/v1/me/player/currently-playing`;
const RECENTLY_PLAYED_ENDPOINT = `https://api.spotify.com/v1/me/player/recently-played`;
const TOKEN_ENDPOINT = `https://accounts.spotify.com/api/token`;

const CLIENT_ID = (process.env.REACT_APP_SPOTIFY_CLIENT_ID || "").trim();
const CLIENT_SECRET = (process.env.REACT_APP_SPOTIFY_CLIENT_SECRET || "").trim();
const REFRESH_TOKEN = (process.env.REACT_APP_SPOTIFY_REFRESH_TOKEN || "").trim();

const getAccessToken = async () => {
  if (!CLIENT_ID || !CLIENT_SECRET || !REFRESH_TOKEN) {
    throw new Error(
      "Missing Spotify credentials. Ensure REACT_APP_SPOTIFY_CLIENT_ID, REACT_APP_SPOTIFY_CLIENT_SECRET, and REACT_APP_SPOTIFY_REFRESH_TOKEN are set in your .env file."
    );
  }

  // Base64 encode client_id:client_secret using browser-native btoa
  const basic = btoa(`${CLIENT_ID}:${CLIENT_SECRET}`);

  const response = await fetch(TOKEN_ENDPOINT, {
    method: "POST",
    headers: {
      Authorization: `Basic ${basic}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      grant_type: "refresh_token",
      refresh_token: REFRESH_TOKEN,
    }).toString(),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(`Token request failed [${response.status}]: ${errorBody}`);
  }

  return response.json();
};

export const getNowPlaying = async () => {
  const { access_token } = await getAccessToken();

  return fetch(NOW_PLAYING_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

export const getRecentlyPlayed = async () => {
  const { access_token } = await getAccessToken();

  return fetch(RECENTLY_PLAYED_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

export default async function getSongItem() {
  try {
    const response = await getNowPlaying();

    // 200 OK: Playing or paused track
    if (response.status === 200) {
      const song = await response.json();

      if (song && song.item) {
        return {
          albumImageUrl: song.item.album.images[0]?.url ?? "",
          artist: song.item.artists.map((a) => a.name).join(", "),
          songUrl: song.item.external_urls.spotify,
          title: song.item.name,
        };
      }
    }

    // Fallback: Check recently played if 204 No Content or no active item
    const recentResponse = await getRecentlyPlayed();

    if (recentResponse.status !== 200) {
      return false;
    }

    const recentData = await recentResponse.json();

    if (!recentData.items || recentData.items.length === 0) {
      return false;
    }

    const track = recentData.items[0].track;

    return {
      albumImageUrl: track.album.images[0]?.url ?? "",
      artist: track.artists.map((a) => a.name).join(", "),
      songUrl: track.external_urls.spotify,
      title: track.name,
    };
  } catch (error) {
    console.error("Spotify API Failure:", error);
    return false;
  }
}